import { useParams } from 'react-router-dom'

export const useActiveConversationId = () => {
  const { conversationId: activeConversationId = '' } = useParams()

  return {
    activeConversationId,
  }
}
